const COMPONENT_NAME = "ProductImage";
export {
  COMPONENT_NAME
};
